export function ThinkingIndicator() {
  return (
    <div className="flex items-center gap-1.5 py-2 animate-cx-fade-in">
      <span className="cx-thinking-dot" />
      <span className="cx-thinking-dot cx-thinking-dot--2" />
      <span className="cx-thinking-dot cx-thinking-dot--3" />
    </div>
  );
}
